// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarFormacion_main__9dxzQ","intro":"ModalEditarFormacion_intro__ZpMfk","input":"ModalEditarFormacion_input__WbROH"};